import { Check, RotateCcw, X } from 'lucide-react';

import { Button } from '@/components/ui';
import type {
  HumanReviewDecisionResult,
  HumanReviewRequestState,
} from '@/lib/admin/client';

export type DecisionButtonsProps = {
  onDecide: (action: HumanReviewDecisionResult) => void;
  disabled: boolean;
  state: HumanReviewRequestState;
  // When the item already has a decision, the buttons frame the action as a
  // correction (append a superseding decision) rather than a first decision.
  correction: boolean;
};

export function DecisionButtons({
  onDecide,
  disabled,
  state,
  correction,
}: DecisionButtonsProps) {
  if (state === 'expired') {
    return (
      <Button
        type="button"
        variant="warning"
        size="sm"
        onClick={() => onDecide('reopened')}
        disabled={disabled}
      >
        <RotateCcw className="h-4 w-4" aria-hidden="true" />
        Reopen
      </Button>
    );
  }

  return (
    <>
      <Button
        type="button"
        variant="warning"
        size="sm"
        onClick={() => onDecide('changes_requested')}
        disabled={disabled}
      >
        {correction ? 'Change to needs changes' : 'Needs changes'}
      </Button>
      <Button
        type="button"
        variant="destructive"
        size="sm"
        onClick={() => onDecide('rejected')}
        disabled={disabled}
      >
        <X className="h-4 w-4" aria-hidden="true" />
        {correction ? 'Change to reject' : 'Reject'}
      </Button>
      <Button
        type="button"
        variant="success"
        size="sm"
        onClick={() => onDecide('approved')}
        disabled={disabled}
      >
        <Check className="h-4 w-4" aria-hidden="true" />
        {correction ? 'Change to approve' : 'Approve'}
      </Button>
    </>
  );
}
